<div *ngIf="users!==[]||users">
  <div class="avatars" *ngIf="users?.length>4; else elseBlock">
    <span class="avatar" *ngFor="let user of firstFourUser; index as i">
      <img *ngIf="i<3" [src]="getProfilePic(user)">
      <div class="avatarMore" *ngIf="i===3">+{{users.length - 3}}</div>
      </span>
  </div>
  <ng-template #elseBlock>
    <div class="avatars" *ngIf="users?.length>0&& users?.length<5">
      <span class="avatar" *ngFor="let user of users; index as i">
      <img *ngIf="i<3" [src]="getProfilePic(user)">
      </span>
    </div>
  </ng-template>
</div>
